import { useEffect } from 'react';
import AuthService from '../services/auth.service';
import SsoLoginPage from './SsoLoginPage';

export default function ExtLogin() {
  const authService = AuthService.getInstance();
  const showSsoLogin = authService.isCustomDomain && authService.ssoEnabled;

  useEffect(() => {
    if (showSsoLogin) return;

    if (authService.isCustomDomain && authService.returnToken) {
      const returnTo = encodeURIComponent(window.location.origin);
      const token = encodeURIComponent(authService.returnToken);
      window.location.href = `${authService.authAppUrl}/login?returnTo=${returnTo}&returnToken=${token}`;
    } else if (authService.isCustomDomain) {
      window.location.href = `${authService.authAppUrl}/login`;
    } else {
      window.location.href = `${authService.authAppUrl}/login`;
    }
  }, []);

  if (showSsoLogin) {
    return <SsoLoginPage />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-gray-500">Redirecting to login...</div>
    </div>
  );
}
